import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiPoll, PagedArray, PollsApi } from '@tytapp/api';
import { PageComponent } from '@tytapp/common';
import { UserService } from '@tytapp/user';


@Component({
    selector: 'tyt-all-petitions',
    templateUrl: './all-petitions.component.html',
    styleUrls: ['./all-petitions.component.scss']
})
export class AllPetitionsComponent extends PageComponent {
    private pollsApi = inject(PollsApi);
    private userService = inject(UserService);


    _statuses = ['published', 'closed', 'draft', 'all'] as const;
    get statuses() {
        return this.user?.staff ?
            this._statuses :
            this._statuses.filter(status => status !== 'draft')
    }

    page: number;
    selectedStatus: string;
    petitions: PagedArray<ApiPoll>;

    draftPetitions: ApiPoll[];
    publishedPetitions: ApiPoll[];

    get user() {
        return this.userService.user;
    }

    init() {
        this.route.queryParamMap.subscribe(map => {
            this.selectedStatus = map.get('status') || 'all';
            this.page = Number(map.get('page')) || 1;
            this.fetchPetitions();
        });
    }

    async fetchPetitions() {
        this.petitions = await this.pollsApi.all(this.selectedStatus, 'Petition', undefined, this.page).toPromise();
        this.draftPetitions =
            this.user?.staff &&
            this.selectedStatus.match(/^(draft|all)$/) &&
            this.petitions.filter(
                petition => petition.status === 'draft'
            );
        this.publishedPetitions =
            this.selectedStatus !== 'draft' &&
            this.petitions.filter(
                petition => petition.status !== 'draft'
            );
    }

    switchStatus(status: string) {
        this.router.navigate([], {
            queryParams: {
                status
            }
        });
    }

    goToPage(page) {
        this.router.navigate([], {
            queryParams: {
                status: this.selectedStatus,
                page
            }
        });
    }

    async onPetitionDelete(petition: ApiPoll) {
        await this.pollsApi.triggerPollEvent(petition.id, 'archive').toPromise();
        this.fetchPetitions();
    }
}
